import React from 'react'
import { Button } from 'baby-design'
import { ContributeProps } from './Contribute.types'
import css from './Contribute.styles.scss'

const Contribute: React.FC<ContributeProps> = () => (
  <div className={css.Contribute} data-testid="ContributeButton">
    <Button size="sm" variant="primary">
      Contribute
    </Button>
  </div>
)

export default Contribute
